import { render, staticRenderFns } from "./tabVesselGeneralInfo.vue?vue&type=template&id=4224bacc&scoped=true&"
import script from "./tabVesselGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./tabVesselGeneralInfo.vue?vue&type=script&lang=js&"
import style0 from "./tabVesselGeneralInfo.vue?vue&type=style&index=0&id=4224bacc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4224bacc",
  null
  
)

export default component.exports